module.exports = __webpack_public_path__ + "static/media/house.5edec108.svg";